import './Admissions_consultant.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HongButton from '../comm/HongButton';
import CheckboxMui from '../comm/CheckboxMui';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AddressDaum from '../page_login/AddressDaum';
import Admissions_consultant_content from './Admissions_consultant_content';
import Admissions_consultant_price from './Admissions_consultant_price';

const Admissions_consultant = () => {
  const navigate = useNavigate();

  const [isModal, setIsModal] = useState(false);
  const [userInput, setUserInput] = useState({
    userName: '',
    email: '',
    hp: '',
    zipCode: '',
    address1: '',
    address2: '',

    zipCode_co: '',
    address1_co: '',
    address2_co: '',

    bank: '',
    banknumber: '',
    university_name: '',
    university_major: '',
    graduate_name: '',
    graduate_major: '',
    career: '',
    agreement_terms: '',
  });

  const [parentCode, setParentCode] = useState(null);
  const [service_master, setService_master] = useState([]);
  const [selected_service_master, setSelected_service_master] = useState([]);
  const [regionMaster, setRegionMaster] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const [files, setFiles] = useState({});
  const [fileNames, setFileNames] = useState({});




  useEffect(() => {
    fncConsulting_service_master();
    fncConsulting_region_master();
    const userCode = fnc.fncSirialNum('p');//여기서 코드 발급
    setParentCode(userCode);
  }, []);

  
  function fncConsulting_service_master() {//특목, 사관학교, 과기원..
    fnc.sendAxios('/igongAdmissions_consultantRoutes/select/set_consulting_service_master', { }, (res) => {
      if (res && res.length > 0) {
          setService_master(res);
      } else {
        console.log("속성이 obj 내에 없습니다.");
      }
    });
  }

   const handleCheckboxChange_service_master = (itemCode) => {
    setSelected_service_master((prev) =>
      prev.includes(itemCode)
        ? prev.filter((code) => code !== itemCode)
        : [...prev, itemCode]
    );

  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddressChange = (address, zipCode) => {
    setUserInput((prev) => ({
      ...prev,
      address1: address,
      zipCode,
    }));
  };

  const handleAddressChangeCo = (address, zipCode) => {
    setUserInput((prev) => ({
      ...prev,
      address1_co: address,
      zipCode_co: zipCode,
    }));
  };

  //-----------------------------------------------------------------------------
   function fncConsulting_region_master() {//특목, 사관학교, 과기원..
    fnc.sendAxios('/igongAdmissions_consultantRoutes/select/set_consulting_region_master', { }, (res) => {
      if (res && res.length > 0) {
          console.log(res, 'region res');
          setRegionMaster(res); 
      } else {
        console.log("속성이 obj 내에 없습니다.");
      }
    });
  }

  const handleCheckboxChangeRegion = (region_code) => {
    setSelectedRegions((prev) =>
      prev.includes(region_code)
        ? prev.filter(code => code !== region_code)
        : [...prev, region_code]
    );
    console.log(selectedRegions, 'selectedRegions');
  };

  const groupRegionsByGroup = (regionMaster) => {
    const grouped = {};
    regionMaster.forEach(region => {
      if (!grouped[region.region_group]) {
        grouped[region.region_group] = [];
      }
      grouped[region.region_group].push(region);
    });
    return grouped;
  };




  //-----------------------------------------------------------------------------
  const validateForm = () => {
    const requiredFields = [
      'userName',
      'email',
      'hp',
      'address1',
      'address2',
      'bank',
      'banknumber',
      'university_name',
      'university_major',
      'graduate_name',
      'graduate_major',
      'career'
    ];
    if (userInput.agreement_terms !== true) {
      alert('위 계약에 동의가 필요합니다.');
      return false;
    }
    if (!userInput.userName?.trim()) {
      alert('이름을 입력하세요.');
      return false;
    }

    if (!/^\S+@\S+\.\S+$/.test(userInput.email)) {
      alert('유효한 이메일 형식을 입력해 주세요.');
      return false;
    }

    if (!/^\d{10,11}$/.test(userInput.hp)) {
      alert('유효한 휴대전화 번호를 입력해 주세요.');
      return false;
    }

    if (!userInput.address1?.trim()) {
      alert('주소를 입력하세요.');
      return false;
    }
    if (!userInput.address2?.trim()) {
      alert('상세주소를 입력하세요.');
      return false;
    }

    if (!userInput.address1_co?.trim()) {
      alert('근무지 주소를 입력하세요.');
      return false;
    }
    if (!userInput.address2_co?.trim()) {
      alert('근무지 상세주소를 입력하세요.');
      return false;
    }

    if (!userInput.bank?.trim()) {
      alert('은행명을 입력하세요.');
      return false;
    }

    if (!/^\d{9,20}$/.test(userInput.banknumber)) {
      alert('유효한 계좌번호를 입력해 주세요. (숫자만, 9~20자리)');
      return false;
    }

    if (!userInput.university_name?.trim() || !userInput.university_major?.trim()) {
      alert('대학교명과 전공을 모두 입력해 주세요.');
      return false;
    }
    if (!userInput.graduate_name?.trim() || !userInput.graduate_major?.trim()) {
      alert('대학원명과 전공을 모두 입력해 주세요.');
      return false;
    }

    if (!userInput.career?.trim()) {
      alert('이력 | 경력사항을 입력해 주세요.');
      return false;
    }

    if (selected_service_master.length === 0) {
      alert('입시컨설팅 전문영역을 1개 이상 선택해 주세요.');
      return false;
    }
    if (selectedRegions.length === 0) {
      alert('입시컨설팅 가능지역을 1개 이상 선택해 주세요.');
      return false;
    }

    //--------------------------
    if (!files.photo_self) {
      alert('본인 사진을 첨부해 주세요.');
      return false;
    }
    if (!files.photo_id) {
      alert('신분증 사진을 첨부해 주세요.');
      return false;
    }
    if (!files.photo_biz) {
      alert('사업자 등록증 사진을 첨부해 주세요.');
      return false;
    }
    if (!files.photo_bank) {
      alert('통장 사본 사진을 첨부해 주세요.');
      return false;
    }
    return true;
  };
  

//----------------------------------------------------------------------등록
  function fncInsertConsultant() {
  if (!validateForm()) return;

  const rtn = window.confirm('입시컨설턴트를 등록하시겠습니까?');
  if (!rtn) return;

  fnc.sendAxios('/igongAdmissions_consultantRoutes/insert/admissions_consultant_agreement', {
    userCode: parentCode,
    userName: userInput.userName,
    email: userInput.email,
    hp: userInput.hp,
    zipCode: userInput.zipCode,
    address1: userInput.address1,
    address2: userInput.address2,

    zipCode_co: userInput.zipCode_co,
    address1_co: userInput.address1_co,
    address2_co: userInput.address2_co,

    bank: userInput.bank,
    banknumber: userInput.banknumber,

    university_name: userInput.university_name,
    university_major: userInput.university_major,
    graduate_name: userInput.graduate_name,
    graduate_major: userInput.graduate_major,

    career: userInput.career,
    agreement_terms: userInput.agreement_terms ? '동의함' : '동의 안함',

  }, (res) => {
    if (!res) {
      alert('등록에 실패했습니다.');
      return;
    }

     if (res.success === 'exist') {
          alert('이미 등록된 정보가 존재합니다.');
      } else if (res.success === true) {
          // alert('입시컨설턴트 등록이 완료되었습니다.'); 
        fncInsert_service_all(parentCode);
        fncUploadAll();
          
      }

  });
}




//--------------------------------------------------------------------서비스대상 추가

function fncInsert_service_all(parent_code) {
 
  let completed = 0; // 완료된 삽입 작업을 추적
  const total = selected_service_master.length;

  selected_service_master.forEach((service_code) => {
      fncInsert_service(parent_code, service_code, () => {
          completed++;
          if (completed === total) {
                fncInsert_regions_all(parent_code);     
          }
      });
  });
}


function fncInsert_service(parent_code, service_code, callback) {
  fnc.sendAxios('/igongAdmissions_consultantRoutes/insert/service', { parent_code, service_code }, (res) => {
    if (res) {
      callback();
    } else {
      console.log(res, "loginRoutes/insert/user_aca_studentKind");
    }
  });
}


//--------------------------------------------------------------------가능지역 추가

function fncInsert_regions_all(parent_code) {
 
  let completed = 0; // 완료된 삽입 작업을 추적
  const total = selectedRegions.length;

  selectedRegions.forEach((region_code) => {
      fncInsert_regions(parent_code, region_code, () => {
          completed++;
          if (completed === total) {
              // navigate(-1);
              // alert('완료되었습니다.');              
          }
      });
  });
}


function fncInsert_regions(parent_code, region_code, callback) {
  fnc.sendAxios('/igongAdmissions_consultantRoutes/insert/region', { parent_code, region_code }, (res) => {
    if (res) {
      callback();
    } else {
      console.log(res, "loginRoutes/insert/user_aca_studentKind");
    }
  });
}


//-----------------------------------------------------파일 업로드
    const handleFileChange = (e) => {
    // const { name, files: inputFiles } = e.target;//구조분해 아래와 같다.
    const name = e.target.name;
    const inputFiles = e.target.files;//파일을 한개만 선택하니까 inputFiles[0]

    if (inputFiles.length > 0 && inputFiles[0]) {
      setFiles(prev => ({ ...prev, [name]: inputFiles[0] }));
      setFileNames(prev => ({ ...prev, [name]: inputFiles[0].name }));
    } else {
      // 파일 선택 취소 시 해당 항목 제거
      setFiles(prev => {
        const newFiles = { ...prev };
        delete newFiles[name];
        return newFiles;
      });
      setFileNames(prev => {
        const newNames = { ...prev };
        delete newNames[name];
        return newNames;
      });
    }
  };



function fncUploadAll() {

    handleUpload(files.photo_self, 'self','F01');
    handleUpload(files.photo_id, 'id','F02');
    handleUpload(files.photo_biz, 'biz','F03');
    handleUpload(files.photo_bank, 'bank','F04');

    
  // 3초 후 완료 알림
  setTimeout(() => {
    alert('완료되었습니다.');
    // navigate(-1); // 페이지 이동이 필요하면 주석 해제
  }, 2000); // 3000ms = 3초

}


const handleUpload = async (file, filePrefix, titleCode) => {

  try {

    const expireSec = 600; // presigned URL 유효시간 (초)
    const fileCode = fnc.getSafeFileName(file.name, filePrefix);
    const folder = 'upload/consultant';
    const orgFileName = file.name;

    fnc.sendAxios('/generate-upload-url', {fileName: fileCode, fileType: file.type,
      folder: folder, sec: expireSec}, (presignedRes) => {
      if (presignedRes) {
          const { url, key } = presignedRes; 
          fncS4.axiosPutFile(url, file); // 2. presigned URL로 S3에 직접 파일 PUT
          fncInsertUploadRecord( parentCode, fileCode, orgFileName, titleCode);
        } else {
          console.log('Error during file download');
        }    
      }); 
     
  } catch (err) {
    console.error('업로드 중 오류 발생:', err);
    alert('오류가 발생했습니다.');
  }
};


function fncInsertUploadRecord( parentCode, fileCode, fileName, titleCode) {
  const code = fnc.fncSirialNum('c');
  const extension = fileName.split('.').pop();
  const kind = extension;

  fnc.sendAxios(`/igongAdmissions_consultantRoutes/uploadRecord`, {
    parentCode, fileCode, fileName, code, kind, titleCode }, (res) => {
    if (res) {
      // alert('완료되었습니다.');
    } else {
      console.log('uploadRecord 저장 중 오류');
    }
  });
}



  //===================================================================================
  return (
    <S.Section2>
      <div className='Admissions_consultant'>
        <div className='wrap-main'>
       
          <section className='section-consultant'>
            <p className='title'>입시컨설턴트 등록</p>
            <div className='form-container'>

              <Admissions_consultant_content />
              <div className='agreement-box'>
                <CheckboxMui
                  checked={userInput.agreement_terms === true}
                  onChange={e => setUserInput(prev => ({ ...prev, agreement_terms: e.target.checked }))}
                  label="위 계약에 동의합니다."
                  disableRipple={true}
                />
              </div>
              <label>*이름</label>
              <input type='text' name='userName' value={userInput.userName} onChange={handleChange} />

              <label>*이메일</label>
              <input type='email' name='email' value={userInput.email} onChange={handleChange} />

              <label>*휴대전화</label>
              <input type='text' name='hp' value={userInput.hp} onChange={handleChange} placeholder='숫자만 입력' />

              <label>*주소</label>
              <div className='address-box'>
                <input type='text' name='address1' value={userInput.address1} readOnly />
                <HongButton className='btnAddress' onClick={() => setIsModal(true)}>주소검색</HongButton>
                <input className='second' type='text' name='address2' value={userInput.address2} onChange={handleChange} placeholder='상세주소' />
              </div>

              <label>*근무지 주소</label>
              <div className='address-box'>
                <input type='text' name='address1_co' value={userInput.address1_co} readOnly />
                <HongButton className='btnAddress' onClick={() => setIsModal('co')}>주소검색</HongButton>
                <input className='second' type='text' name='address2_co' value={userInput.address2_co} onChange={handleChange} placeholder='상세주소' />
              </div>

              <label>*계좌 정보</label>
              <input type='text' name='bank' value={userInput.bank} onChange={handleChange} placeholder='은행명' />
              <input className='second' type='text' name='banknumber' value={userInput.banknumber} onChange={handleChange} placeholder='숫자만, 9~20자리' />

              {/* 교과목 checkbox */}
              <article className='art-1'>
                <label>*입시컨설팅 전문영역</label>
                <div className='box-chkbox-1'>       
                  {service_master.map((item) => (
                      <CheckboxMui
                        value={item.service_code}
                        checked={selected_service_master.includes(item.service_code)}
                        onChange={() => handleCheckboxChange_service_master(item.service_code)}
                        label={item.service_name}
                        disableRipple={true}
                      />
                    ))}
                </div>
              </article>



              <label>*대학교 / 전공</label>
              <input type='text' name='university_name' value={userInput.university_name} onChange={handleChange}  placeholder='대학교명 입력'/>
              <input className='second' type='text' name='university_major' value={userInput.university_major} onChange={handleChange} placeholder='전공 입력' />

              <label>*대학원 / 전공</label>
              <input type='text' name='graduate_name' value={userInput.graduate_name} onChange={handleChange}  placeholder='대학원명 입력'/>
              <input className='second' type='text' name='graduate_major' value={userInput.graduate_major} onChange={handleChange}  placeholder='전공 입력'/>

              <label>*이력 | 경력사항</label>
              <textarea name='career' value={userInput.career} onChange={handleChange} placeholder='입시중심 상세기술 요망' />

             

              <article className='art-1'>
                <label>*입시컨설팅 가능지역</label>
                {Object.entries(groupRegionsByGroup(regionMaster)).map(([groupName, regions]) => (
                  <div key={groupName} className='box-chkbox-2'>
                    <p className='group-label'>{groupName}</p>
                    {regions.map((region) => (
                      <CheckboxMui
                        key={region.region_code}
                        value={region.region_code}
                        checked={selectedRegions.includes(region.region_code)}
                        onChange={() => handleCheckboxChangeRegion(region.region_code)}
                        label={region.region_name}
                        disableRipple={true}
                      />
                    ))}
                  </div>
                ))}
              </article>
          
          <Admissions_consultant_price />

        {/* 파일첨부 */}
       <section className="sec-photo-upload">
        <div className="upload-row">
          <label>*본인 사진별첨</label>
          <input type="file" name="photo_self" accept="image/*" onChange={handleFileChange} />
          {/* <span>{fileNames.photo_self}</span> */}
        </div>
        <div className="upload-row">
          <label>*신분증 사진별첨</label>
          <input type="file" name="photo_id" accept="image/*" onChange={handleFileChange} />
          {/* <span>{fileNames.photo_id}</span> */}
        </div>
        <div className="upload-row">
          <label>*사업자 등록증 사진별첨</label>
          <input type="file" name="photo_biz" accept="image/*" onChange={handleFileChange} />
          {/* <span>{fileNames.photo_biz}</span> */}
        </div>
        <div className="upload-row">
          <label>*통장 사본 사진별첨</label>
          <input type="file" name="photo_bank" accept="image/*" onChange={handleFileChange} />
          {/* <span>{fileNames.photo_bank}</span> */}
        </div>
        
      </section>

        <div className='box-btn'>
            <HongButton className='btn h-btn-gray' onClick={() => navigate(-1)}>취소</HongButton>
            <HongButton className='btn h-btn-red' onClick={fncInsertConsultant}>등록</HongButton>
             {/* <HongButton className='btn h-btn-red' onClick={fncUploadAll}>파일 업로드 테스트</HongButton> */}
        </div>


        </div>
        </section>
        </div>

        {isModal === true && (
          <div className='box_modal'>
            <AddressDaum setIsModal={setIsModal} handleAddressChange={handleAddressChange} />
          </div>
        )}
        {isModal === 'co' && (
          <div className='box_modal'>
            <AddressDaum setIsModal={setIsModal} handleAddressChange={handleAddressChangeCo} />
          </div>
        )}
      </div>

     

    </S.Section2>
  );
};

export default Admissions_consultant;
